import { JetpacB2BApi, JetpacCatalogApi } from 'api'

class B2BCatalogApi {
  static async getCatalogGroup(faberToken: string) {
    return JetpacB2BApi.httpGet(
      `catalog-group/catalog-group`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }
  static getCatalogGroupById(faberToken: string, id: string) {
    const url = `/catalog-group/${id}`
    return JetpacB2BApi.httpGet(
      url,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }
  static async getCatalogGroupGrid(faberToken: string, search_term?: string) {
    const url = search_term
      ? `catalog-group?search_term=${search_term}`
      : `catalog-group`

    return JetpacB2BApi.httpGet(
      url,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }
  static async getCatalogItems(faberToken: string, id: string) {
    const url = `catalog-group/${id}/catalog-items`

    return JetpacB2BApi.httpGet(
      url,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }

  static async createCatalogGroup(
    body: ICatalogGroupBackendData,
    faberToken: string
  ) {
    return JetpacB2BApi.httpPost(
      `catalog-group`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    )
  }
  static async updateCatalogGroup(
    body: ICatalogGroupBackendData,
    faberToken: string
  ) {
    return JetpacB2BApi.httpPut(
      `catalog-group`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    )
  }
  static updateCatalogGroupStatus(
    body: ICatalogGroupStatus,
    faberToken: string
  ) {
    return JetpacB2BApi.httpPatch(
      `catalog-group/status`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    )
  }

  static async getCatalogs(token, params) {
    const { offset = 0, limit = 25, search,ids } = params

    const queryParams = new URLSearchParams({
      offset: offset.toString(),
      limit: limit.toString()
    })

    if (search && search.trim()) {
      queryParams.append('displayName', search.trim())
    }

    if (ids && ids.length > 0) {
      queryParams.append('ids', ids.join(','))
    }

    return JetpacCatalogApi.httpGet(
      `catalog/ops/items/details?${queryParams.toString()}`,
      {
        Authorization: `Bearer ${token}`
      },
      true
    ).then((res) => res.data)
  }
  catch(error) {
    console.error('Error fetching catalogs:', error)
    throw error
  }
}

export default B2BCatalogApi

export interface ICatalogDetails {
  catalog_destination_id: string
  is_active: boolean

}

export interface ICatalogGroupStatus {
  id: string
  updated_by: string
  status: boolean
}
export interface ICatalogGroupBackendData {
  name: string
  is_active: boolean
  created_by: string
  catalog_group_item: ICatalogDetails[]
  // will only be used when updating
  updated_by?: string
  id?: string
}
